<template>
  <div
    class="admin"
    v-loading="$store.state.loading || componentLoading"
    element-loading-background="rgba(255, 255, 255, .58)"
  >
    <!-- 待审核提示弹窗-->
    <div class="audit-tip" v-if="nums > 0 && show !== 2">
      <span class="tip-text">待审核信息{{ nums }}条</span>
      <span class="close-btn" @click="show = 2">×</span>
    </div>
    <header class="header-wrap">
      <admin-header />
    </header>

    <nav class="nav-wrap" style="margin-top: 22px">
      <admin-nav
        class="nav"
        :rules="rules"
        :current="method"
        @change="changeMethod"
      />
    </nav>

    <main class="main-wrap">
      <admin-menus
        :menus="menus"
        @open="openPage"
        v-if="showMenu && rules.length > 0"
        @breadcrumb-click="handleBreadcrumbClick"
      />
      <top-tab
        :page-list="pageList"
        @change="handleTabChange"
        @close-page="handleTabClose"
        v-if="rules.length > 0"
      />
      <div
        class="main-view"
        v-show="!showMenu && rules.length > 0"
        ref="componentContainer"
      >
        <component v-if="activeComp" :is="activeComp" />
      </div>
    </main>
  </div>
</template>

<script>
import { markRaw } from "vue";
import AdminHeader from "./AdminHeader/AdminHeader";
import AdminNav from "./AdminNav/AdminNav";
import AdminMenus from "./AdminMenus/AdminMenus";
import TopTab from "./TopTab/TopTab";
import localMenus from "@/data/menus";

const componentConfigCache = new Map();
const allNavMenusCache = new Map();
const subMenuPermissionCache = new Map();

const PERMISSION_MAP = {};

export default {
  name: "AdminLayout",
  components: {
    AdminHeader,
    AdminNav,
    AdminMenus,
    TopTab,
  },
  data() {
    return {
      timer: null,
      show: 1,
      nums: 0,
      getwwcLoading: false,
      method: "",
      rules: [],
      showUpdatePassword: false,
      showMenu: true,
      menus: [],
      pageList: [],
      currentPage: -1,
      componentLoading: false,
      componentContainer: null,
      isNavChangeShowMenu: false,
      permissionList: [],
      switching: false,
      activeComp: null,
    };
  },
  mounted() {
    this.times();
    this.user();
    this.zqx();
    if (process.env.VUE_APP_TITLE == "样衣星球测试版") {
      document.title = "样衣星球后台管理测试版";
    } else {
      document.title = "样衣星球后台管理";
    }

    this.qx().then(() => {
      this.getNavs();
    });
    this.getDocSize();
    this.componentContainer = this.$refs.componentContainer;

    window.onresize = () => {
      this.getDocSize();
    };
  },
  beforeUnmount() {
    // 销毁定时器
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    componentConfigCache.clear();
    allNavMenusCache.clear();
    subMenuPermissionCache.clear();
  },
  methods: {
    //获取未审核条数
    async getwwc() {
      if (this.getwwcLoading) return;
      this.getwwcLoading = true;
      try {
        const res = await this.$api.Operation.ProductauditList.wwc({});
        if (res.data.code == "200") {
          this.nums = Number(res.data.data || 0);
          if (this.nums > 0) {
            this.show = 1;
          }
        } else {
          this.$message.error(res.data.msg);
        }
      } catch (err) {
        console.error("获取待审核数量失败", err);
      } finally {
        this.getwwcLoading = false;
      }
    },
    times() {
      // 清除旧定时器
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      // 刚进页面立即获取一次
      this.getwwc();
      // 每十分钟秒获取一次
      this.timer = setInterval(() => {
        this.getwwc();
      }, 600000);
    },

    async zqx(id) {
      console.log("===== 进入zqx =====");
      console.log("zqx接收的id：", id);
      if (!id) {
        console.log("zqx：id为空，直接返回空列表");
        return { data: { list: [] } };
      }

      try {
        const sendata = { parentMenuId: id };
        console.log("zqx：准备请求接口，参数sendata：", sendata);
        const res = await this.$api.Login.LoGIn.ziqx(sendata);
        console.log(`zqx：主菜单${id}接口返回结果：`, res);

        if (res.data.code === "200") {
          subMenuPermissionCache.set(id, res);
        }
        return res;
      } catch (error) {
        console.error(`zqx:获取主菜单${id}的子菜单权限失败：`, error);
        this.$message.error("子菜单权限加载失败");
        return { data: { list: [] } };
      }
    },

    async user() {
      const res = await this.$api.Login.LoGIn.user();
      console.log(res.data.data, "返回的用户信息");
      this.$store.commit("setUserInfo", res.data.data);
    },

    async qx() {
      try {
        this.componentLoading = true;

        const res = await this.$api.Login.LoGIn.qx();
        console.log(res, "里面包揽了什么");

        if (res.data.code === "200") {
          this.permissionList = res.data.data.list.map((item) => item.name);
          console.log(this.permissionList, "是否返回后端的权限列表");
          console.log("主菜单权限获取成功：", this.permissionList);
        } else {
          this.permissionList = [];
          this.$message.warning(res.msg || "暂无主菜单权限");
        }
      } catch (error) {
        console.error("获取主菜单权限失败：", error);
        this.permissionList = [];
        this.$message.error("权限加载失败，请刷新页面重试");
      } finally {
        this.componentLoading = false;
      }
    },

    getDocSize() {
      window.fullHeight = document.documentElement.clientHeight;
      window.fullWidth = document.documentElement.clientWidth;
    },

    async getNavs() {
      const allNavs = localMenus.getNav();
      console.log(allNavs, "定义的网页");

      this.rules = allNavs.filter((nav) =>
        this.permissionList.includes(nav.name)
      );
      console.log(this.rules, "返回的权限是啥");

      if (this.rules.length === 0) {
        this.method = "";
        this.menus = [];
        return;
      }

      await this.changeMethod(this.rules[0]);
    },

    // ==========【修复后的getMenus，还原原始权限解析逻辑】==========
    async getMenus() {
      const currentNav = this.rules.find((item) => item.name === this.method);
      const navId = currentNav?.id || this.method;
      console.log("当前主菜单ID（传给zqx的参数）：", navId);
      const permissionRes = await this.zqx(navId);

      console.log("zqx返回结果：", permissionRes);
      const subMenuPermissions = {};

      permissionRes.data.data.list.forEach((item) => {
        if (
          item.childMenuName &&
          item.childMenuPermissions &&
          item.childMenuPermissions.length
        ) {
          subMenuPermissions[item.childMenuName] = {};
          item.childMenuPermissions.forEach((perm) => {
            const action = "menu";
            subMenuPermissions[item.childMenuName][action] = Boolean(
              Number(perm.delflag)
            );
          });
        }
      });

      console.log("解析后的子菜单权限：", subMenuPermissions);
      let allSubMenus = localMenus.getMenu(this.method);

      this.menus = this.filterSubMenuPermission(
        allSubMenus,
        subMenuPermissions
      );
      console.log(this.menus, "最终给到子菜单的权限列表");
      allNavMenusCache.set(this.method, this.menus);
    },

    filterSubMenuPermission(menus, subMenuPermissions = {}) {
      if (!menus || !menus.length) return [];
      return menus.filter((menu) => {
        const backendPermName = PERMISSION_MAP[menu.name] || menu.name;
        const backendPerms = subMenuPermissions[backendPermName] || {};
        return (
          Object.keys(backendPerms).length > 0 && backendPerms.menu === true
        );
      });
    },

    async changeMethod(item) {
      if (this.switching) return;
      console.log("===== 进入changeMethod =====");
      console.log("点击的主菜单item：", item);
      if (!item?.name) return false;

      if (!this.permissionList.includes(item.name)) {
        this.$message.error(`无【${item.name}】模块访问权限`);
        return;
      }

      this.switching = true;
      try {
        this.currentPage = -1;
        this.activeComp = null;
        await this.$nextTick();

        this.method = item.name;
        await this.getMenus();

        this.showMenu = true;
        this.isNavChangeShowMenu = true;
      } finally {
        this.switching = false;
      }
    },

    async handleBreadcrumbClick(breadcrumbItem) {
      if (!breadcrumbItem?.id) return;
      let targetPage = null;
      let targetNav = "";
      for (const [navKey, menus] of allNavMenusCache.entries()) {
        const matchPage = menus.find((menu) => menu.id === breadcrumbItem.id);
        if (matchPage) {
          targetPage = matchPage;
          targetNav = navKey;
          break;
        }
      }

      if (targetPage) {
        if (!this.permissionList.includes(targetNav)) {
          this.$message.error(`无【${targetNav}】模块访问权限`);
          return;
        }
        if (this.method !== targetNav) {
          const navItem = this.rules.find((item) => item.name === targetNav);
          if (navItem) await this.changeMethod(navItem);
        }
        await this.openPage(targetPage);
      } else {
        this.$message.warning(
          `未找到【${breadcrumbItem.title}】对应的页面配置`
        );
      }
    },

    async openPage(page) {
      if (!this.checkPagePermission(page)) {
        this.$message.error(`无【${page.title}】页面访问权限`);
        return;
      }

      this.isNavChangeShowMenu = false;
      this.showMenu = false;
      this.componentLoading = true;

      try {
        let componentObj = componentConfigCache.get(page.id);
        if (!componentObj) {
          if (typeof page.component === "function") {
            const componentModule = await page.component();
            componentObj = markRaw(componentModule.default);
          } else {
            componentObj = markRaw(page.component);
          }
          componentConfigCache.set(page.id, componentObj);
        }

        const pageCopy = {
          ...page,
          componentObj,
          navMethod: this.method,
        };
        const existIndex = this.pageList.findIndex((i) => i.id === page.id);

        if (existIndex < 0) {
          this.pageList.push(pageCopy);
          await this.renderComponent(this.pageList.length - 1);
        } else {
          await this.renderComponent(existIndex);
        }
      } catch (error) {
        console.error("页面加载失败：", error);
        if (!this.isNavChangeShowMenu) this.showMenu = true;
      } finally {
        this.componentLoading = false;
      }
    },

    checkPagePermission(page) {
      const currentNav = this.rules.find((item) => item.name === this.method);
      const navId = currentNav?.id || this.method;
      const permissionCache = subMenuPermissionCache.get(navId);
      if (
        permissionCache?.data?.code === "200" &&
        permissionCache.data.data?.list
      ) {
        const backendPermName = PERMISSION_MAP[page.name] || page.name;
        const pagePerm = permissionCache.data.data.list.find(
          (item) => item.childMenuName === backendPermName
        );
        if (pagePerm && pagePerm.childMenuPermissions) {
          const viewPerm = pagePerm.childMenuPermissions.find(
            (perm) =>
              perm.name === `${backendPermName}:menu` ||
              perm.name === "menu:view"
          );
          return viewPerm ? Boolean(Number(viewPerm.delflag)) : false;
        }
      }
      return false;
    },

    async renderComponent(index) {
      if (index < 0 || index >= this.pageList.length) {
        this.activeComp = null;
        this.showMenu = this.pageList.length === 0;
        return;
      }
      await this.$nextTick();
      const targetPage = this.pageList[index];
      this.currentPage = index;
      this.activeComp = targetPage.componentObj;
    },

    handleTabChange(index) {
      if (this.componentLoading || this.switching) return;
      this.showMenu = false;
      this.isNavChangeShowMenu = false;
      this.renderComponent(index);
    },

    handleTabClose(index) {
      if (index < 0 || index >= this.pageList.length) return;
      if (this.componentLoading || this.switching) return;

      let targetIndex = index;
      if (index === this.currentPage) {
        targetIndex = index < this.pageList.length - 1 ? index : index - 1;
      }

      const closedPage = this.pageList[index];
      componentConfigCache.delete(closedPage.id);
      this.pageList.splice(index, 1);

      if (this.pageList.length === 0) {
        this.activeComp = null;
        this.showMenu = true;
        this.currentPage = -1;
      } else {
        targetIndex = Math.max(0, targetIndex);
        this.renderComponent(targetIndex);
        this.showMenu = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./admin";

:deep(.el-loading-mask) {
  z-index: 1001 !important;
}

.no-permission {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  background: #f5f7fa;
  margin: 10px;
  border-radius: 4px;
}
.audit-tip {
  position: absolute;
  right: 12px;
  bottom: 12px;
  height: 88px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid red;
  border-radius: 6px;
  padding: 8px 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  z-index: 10;

  .tip-text {
    font-size: 18px;
    color: red;
  }
  .close-btn {
    cursor: pointer;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.06);
    font-size: 14px;
    color: #666;
    line-height: 1;
    &:hover {
      background: rgba(0, 0, 0, 0.12);
    }
  }
}
</style>